export const siteDetails = {
  name: "Ascot Lodge Nursing Home",
  shortName: "Ascot Lodge",
  phoneDisplay: "01704 538470",
  phoneHref: "tel:+441704538470",
  email: "ascotlodge@hotmail.co.uk",
  addressLines: [
    "38 Chambres Road",
    "Southport",
    "Merseyside",
    "PR8 6JQ",
  ],
  addressInline: "38 Chambres Road, Southport, Merseyside, PR8 6JQ",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=38%20Chambres%20Road%2C%20Southport%2C%20PR8%206JQ",
  cqcUrl: "https://www.cqc.org.uk/location/1-14533438471",
  cqcReportDate: "22 November 2023",
};

export const navigation = [
  { label: "Home", href: "#home", section: "home" },
  { label: "About", href: "#about", section: "about" },
  { label: "Our care", href: "#care", section: "care" },
  { label: "The home", href: "#facilities", section: "facilities" },
  { label: "FAQs", href: "#faqs", section: "faqs" },
  { label: "Contact", href: "#contact", section: "contact" },
];

export const careServices = [
  {
    icon: "heart",
    title: "Nursing and personal care",
    description:
      "Support with nursing needs, personal care and daily routines, shaped around each resident's assessed needs.",
  },
  {
    icon: "home",
    title: "A home for older people",
    description:
      "Ascot Lodge supports older people, including people living with dementia, in a familiar residential setting.",
  },
  {
    icon: "people",
    title: "Individual routines",
    description:
      "Care is organised around the person—their preferences, abilities, interests and the things that matter to them.",
  },
  {
    icon: "meal",
    title: "Meals and dietary needs",
    description:
      "Freshly prepared meals support residents' dietary requirements, comfort and enjoyment throughout the day.",
  },
  {
    icon: "sun",
    title: "Activities and companionship",
    description:
      "Everyday opportunities for conversation, activities and time together help residents stay connected and engaged.",
  },
  {
    icon: "medical",
    title: "Coordinated support",
    description:
      "The team works with local health professionals and families to help residents receive joined-up support.",
  },
];

export const facilities = [
  { icon: "access", title: "Wheelchair access" },
  { icon: "lift", title: "Lift access to all floors" },
  { icon: "garden", title: "Private enclosed garden" },
  { icon: "room", title: "Comfortable private rooms" },
  { icon: "tv", title: "Phone and television points" },
  { icon: "chair", title: "Own furniture by arrangement" },
  { icon: "paw", title: "Pets considered by arrangement" },
  { icon: "location", title: "Close to local amenities" },
];

export const faqs = [
  {
    question: "What type of care does Ascot Lodge provide?",
    answer:
      "Ascot Lodge is a care home with nursing care for older people. Support can include nursing and personal care, and care for people living with dementia. Please contact the home so the team can discuss an individual's needs with you.",
  },
  {
    question: "How many people live at Ascot Lodge?",
    answer:
      "The home is registered to support up to 18 people. Its smaller scale helps create a familiar, welcoming environment.",
  },
  {
    question: "Can we arrange a visit?",
    answer:
      "Yes. Call or send an enquiry and the team will help you arrange a suitable time to look around, ask questions and talk through the care you are seeking.",
  },
  {
    question: "Can residents bring their own belongings?",
    answer:
      "Residents may bring their own furniture by arrangement, along with familiar belongings that help their room feel personal. The team can advise what will fit safely before a move.",
  },
  {
    question: "Is the home accessible?",
    answer:
      "The adapted four-floor building has wheelchair access and a lift serving all floors. If you have a particular accessibility need, please ask the team before visiting.",
  },
  {
    question: "How do I ask about fees or availability?",
    answer:
      "Fees and availability can change, so please contact Ascot Lodge for current information and a conversation about the care required.",
  },
  {
    question: "Are there current job opportunities?",
    answer:
      "Vacancies change over time. Choose Careers on the enquiry form, or call the home, to ask about current opportunities and the application process.",
  },
];
